import React, { useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Button } from "devextreme-react";
import { useTheme } from "@emotion/react";

export default function QRCode({ userId }) {
  const [url, setUrl] = useState("hello world");
  const qrRef = useRef(null);

  const handlePrint = () => {
    const svgElement = qrRef.current?.querySelector("svg");
    if (!svgElement) {
      alert("QR code not found.");
      return;
    }
    const printWindow = window.open("", "_blank", "width=800,height=600");

    if (!printWindow) {
      alert("Popup blocked. Please allow popups for printing.");
      return;
    }
    const doc = printWindow.document;
    doc.title = "Print QR Code";

    const style = doc.createElement("style");
    style.textContent = `
      body {
        margin: 0;
        font-family: Arial, sans-serif;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        background: white;
      }
 
      .print-container {
        text-align: center;
        padding: 20px;
       border: 1px solid black;
      }
 
      .qr-box {
        display: inline-block;
        padding: 20px;
        background: white;
      }
 
      @page {
        margin: 12mm;
      }
    `;
    doc.head.appendChild(style);

    const html = doc.documentElement;
    const head = doc.head;
    const body = doc.body;

    // Container
    const container = doc.createElement("div");
    container.className = "print-container";

    const heading = doc.createElement("h2");
    heading.textContent = "QR Code";

    const qrBox = doc.createElement("div");
    qrBox.className = "qr-box";

    // Clone the SVG from current page
    const svgClone = svgElement.cloneNode(true);
    qrBox.appendChild(svgClone);
    const userText = doc.createElement("p");
    userText.style.marginTop = "16px";

    container.appendChild(heading);
    container.appendChild(qrBox);
    container.appendChild(userText);
    body.appendChild(container);

    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  };
  return (
    <div className="qr-code">
      <div ref={qrRef} style={{ textAlign: "center", padding: "10px" }}>
        <h5 className="gray">Print Personal QR Code</h5>
        <QRCodeSVG
          value={userId}
          title="Sacn to get the User Id"
          size={200}
          bgColor={"#636363"}
          fgColor={"#ffffff"}
          level={"L"}
          includeMargin={true}
        />
        <div style={{ marginTop: "10px" }}>
          <Button
            text="Print"
            type="outlined"
            style={{ marginTop: "12px" }}
            onClick={handlePrint}
          />
        </div>
      </div>
    </div>
  );
}
